export type AuditReturnContext =
  | {
      origin: 'search'
      q: string
      radius_km: number
      page: number
    }
  | {
      origin: 'land-use'
      lat: number
      lon: number
      radius_m: number
      page: number
    }

/** State passed to /fires/:id via location.state when navigating from Home, History, Map or Audit */
export interface ReturnContext {
  returnTo: 'home' | 'history' | 'map' | 'audit'
  home?: { scrollY: number }
  history?: { search?: string; scrollY?: number }
  map?: { selectedFireId?: string }
  audit?: AuditReturnContext
}


/** State passed back to Home or Map via location.state when returning from detail */
export interface RestoreContext {
  restore: { scrollY?: number; selectedFireId?: string }
}

/** sessionStorage key for backup return context */
export const RETURN_CONTEXT_KEY = 'fg:return_context'
